<section class="flex flex-col gap-4">
  <p class="x-font-body-4 x-text-dark-secondary">
    {{ 'owner_filter_dialog.hint' | translate }}
  </p>

  <!-- Заказчик (одиночный выбор с поиском по названию) -->
  <tui-textfield
    [stringify]="stringifyFn"
    [tuiTextfieldCleaner]="true"
    tuiTextfieldSize="m"
    tuiDropdownLimitWidth="fixed"
    [title]="'owner_filter_dialog.owner_placeholder' | translate"
  >
    <label tuiLabel>
      {{ 'owner_filter_dialog.owner_placeholder' | translate }}
    </label>

    <input
      tuiComboBox
      [(ngModel)]="selectedOwner"
      (input)="search = $any($event.target).value"
    />
    <tui-data-list *tuiDropdown>
      @for (
        counterparty of filterCounterparties(counterparties, search);
        track counterparty.id
      ) {
        <button tuiOption [value]="counterparty" [title]="counterparty.name">
          {{ counterparty.name }}
        </button>
      }
    </tui-data-list>
  </tui-textfield>

  <footer class="flex gap-3 justify-end mt-2">
    <button tuiButton appearance="secondary" size="m" (click)="reset()">
      {{ 'owner_filter_dialog.reset' | translate }}
    </button>
    <button tuiButton appearance="primary" size="m" (click)="apply()">
      {{ 'owner_filter_dialog.apply' | translate }}
    </button>
  </footer>
</section>
